var icon = require('vue-svgicon')
icon.register({
  'ks-icon-w9': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<path pid="0" fill-rule="evenodd" d="M78 12l28 28v66.67a9.33 9.33 0 0 1-9.33 9.33H31.33a9.33 9.33 0 0 1-9.33-9.33V21.33A9.3 9.3 0 0 1 31.33 12H78zm-8.642 21h-10.61v7.44c-6.844 1.417-12.361 5.787-12.361 12.437 0 7.846 6.566 11.81 16.21 14.126l.41.097c8.845 2.067 10.61 5.1 10.61 8.304 0 2.376-1.735 6.163-9.549 6.163-7.283 0-10.148-3.167-10.61-7.234H45.75c.424 7.544 6.222 11.81 13.013 13.19V95h10.61v-7.381c6.897-1.203 12.377-5.167 12.377-12.23 0-9.802-8.595-13.109-16.62-15.175-8.027-2.03-10.611-4.134-10.611-7.381 0-3.757 3.57-6.37 9.55-6.37 6.297 0 8.632 2.952 8.844 7.233h7.814c-.25-5.905-3.964-11.366-11.369-13.123V33z"/>'
  }
})
